import PropTypes from "prop-types"
import { useContext, useMemo, useState } from "react"
import { IoMdAddCircleOutline } from "react-icons/io"
import { useQuery } from "react-query"
import { listCertifications } from "~/actions/certifications"
import { listPublishedCourses } from "~/actions/clients"
import { listPaths } from "~/actions/paths"
import Spinner from "~/components/Common/Spinner"
import AppContext from "~/contexts/App"
import ResourceAdded from "../../ReactHookForms/ResourceAdded"
import AddResourceDialog from "../AddResourceDialog"

const ATTACH_OPTIONS = ["course", "certification", "path"]

const AttachDoc = () => {
  const dialogInitialValues = {
    open: false,
    type: "course",
    cardImageKey: "thumbnail",
  }
  const { authUser } = useContext(AppContext)
  const [openDialog, setOpenDialog] = useState(dialogInitialValues)

  const closeDialog = () => setOpenDialog(dialogInitialValues)

  const { data: publishedCourses, isLoading: coursesLoading } = useQuery(
    "publishedCourses",
    () => listPublishedCourses(),
    {
      enabled: !!authUser,
    },
  )

  const { data: paths, isLoading: pathsLoading } = useQuery("paths", listPaths)

  const { data: certifications, isLoading: certificationsLoading } = useQuery(
    "certifications",
    listCertifications,
  )

  const loading = coursesLoading || pathsLoading || certificationsLoading

  const resourcesData = useMemo(() => {
    if (openDialog.type === "course") return publishedCourses
    if (openDialog.type === "certification")
      return certifications.filter((c) => c.published)
    if (openDialog.type === "path") return paths.filter((p) => p.published)
  }, [openDialog])

  return (
    <div className="h-full px-8">
      {ATTACH_OPTIONS.map((option) => (
        <div key={option} className="mb-10">
          <div className="flex items-center justify-between mb-10">
            <h3 className="capitalize">{option + "s"}</h3>
            <button
              className="flex items-center bg-[#09295829] hover:bg-gray4 p-2 rounded-md"
              onClick={() => {
                setOpenDialog({
                  open: true,
                  type: option,
                })
              }}
            >
              {loading ? (
                <Spinner />
              ) : (
                <>
                  <IoMdAddCircleOutline
                    className="w-6 h-6 mr-2"
                    color="#092958"
                  />
                  <p className="uppercase text-sm font-medium">Add {option}</p>
                </>
              )}
            </button>
          </div>
          <ResourceAdded id={option} />
        </div>
      ))}

      <AddResourceDialog
        open={openDialog.open}
        closeDialog={closeDialog}
        data={resourcesData}
        type={openDialog.type}
      />
    </div>
  )
}

AttachDoc.propTypes = {
  doc: PropTypes.object,
}

export default AttachDoc
